module.exports = __webpack_public_path__ + "media/images/comments-6235fbf29d32d9c09f3b2167bf167299.svg";